
// Flatten nested objects to dot notation
export const flattenObject = (obj: Record<string, any>, prefix = '') => {
  return Object.keys(obj).reduce((acc: Record<string, any>, key: string) => {
    const prefixKey = prefix ? `${prefix}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(acc, flattenObject(obj[key], prefixKey));
    } else {
      acc[prefixKey] = obj[key];
    }
    return acc;
  }, {});
};

// Translation interface
export interface Translation {
  key: string;
  en: string;
  no: string;
}
